
<template>
  <div class="speech-bubble answer" @click="clicked" v-bind:id="'answer' + getId()" v-bind:class="element.animation" style="position:relative;">
    {{element.text}}
    <span v-if="removable == true"  @click="remove" style="position:absolute;right:-25px; cursor:pointer; color:black;">x</span>
  </div>
</template>

<script>
  export default {
    name: 'onboarding-answer',
    components: {
    },
    props: {
      element: {
        required: false,
        type: Object,
        default() {
          return { extra: null, animation: "" }
        }
      },
      removable: {
        required: false,
        type: Boolean,
        default: false
      },
      step: {
        required: false,
        type: Object,
        default() {
          return null
        }
      },
    },
    data() {
      return {
      }
    },
    methods: {
      remove() {
        this.$emit("removeanswer", this.element, this.step)
      },
      getId() {
        return this._uid;
      },
      hide() {
        $('#answer' + this.getId()).hide();
      },
      show() {
        $('#answer' + this.getId()).show();
      },
      clicked() {
        if (this.element.goto) {
          this.$emit("goto", this.element.goto)
        }
      }
    },
    created() {

    },
    mounted() {

    }
  }
</script>

<style scoped>

  .speech-bubble {
    position: relative;
    background: #349526;
    border-radius: .4em;
    padding-top: 20px;
    padding-left: 40px;
    padding-right: 40px;
    padding-bottom: 20px;
    font-size: 24px;
    color: white;
    float: left;
    left: 30px;
    max-width: 60%;
  }

    .speech-bubble:after {
      content: '';
      position: absolute;
      left: 1px;
      top: 50%;
      width: 0;
      height: 0;
      border: 45px solid transparent;
      border-right-color: #349526;
      border-left: 0;
      border-bottom: 0;
      margin-top: -22.5px;
      margin-left: -45px;
    }

  @media (max-width: 768px) {
    .speech-bubble {
      font-size: 18px;
    }
  }

  .delay-1 {
    animation-delay: 1s;
  }

  .delay-2 {
    animation-delay: 2s;
  }

  .delay-3 {
    animation-delay: 3s;
  }

  .delay-4 {
    animation-delay: 4s;
  }


  .duration-1 {
    animation-duration: 1s;
  }

  .duration-2 {
    animation-duration: 2s;
  }

  .duration-3 {
    animation-duration: 3s;
  }

  .duration-4 {
    animation-duration: 4s;
  }

  .duration-5 {
    animation-duration: 5s;
  }

  .duration-6 {
    animation-duration: 6s;
  }

  .duration-7 {
    animation-duration: 7s;
  }

  .duration-8 {
    animation-duration: 8s;
  }

  .duration-9 {
    animation-duration: 9s;
  }

  .duration-10 {
    animation-duration: 10s;
  }
</style>



// WEBPACK FOOTER //
// src/components/onboarding/onboarding-answer.vue